import { setOptions } from '@googlemaps/js-api-loader';
import './animations';
import Config from './config';
import InquiryForm from './inquiry/form';
import LandingSearch from './landing-search';
import NewsletterForm from './newsletterform';
import PropertySearch from './search';

// Define global RJ object
window.RJ = window.RJ || {};

// Define global RJ config and assign theme config
window.HJ.Config = window.HJ.Config || {};
Object.assign(window.HJ.Config, Config);

// Set Google Maps API loader options
setOptions({
    key: window.HJ.Config.gmaps_api_key,
    region: window.HJ.Config.language,
});

// Define global RJ views and assign theme views
window.RJ.Views = window.RJ.Views || {};
Object.assign(window.RJ.Views, {
    InquiryForm,
    LandingSearch,
    NewsletterForm,
    PropertySearch,
});
